<template>
  <div class="config-app">
    <h2 class="app-title">Definições de Comunicação</h2>
<!--    <p class="subtitle"></p>-->

    <div class="m-t-lg">
      Indisponível no momento.
    </div>
  </div>
</template>

<script>
// @TODO: <MIGRATE-2.0>: Fazer insert em person_comunication_history baseado no e-mail dentro do sm_message
import AppMixin from './appMixin'

export default {
  name: "ConfigComunicacao",
  inject: ['config'],
  mixins: [AppMixin],
  data() {
    return {
      active: 'basico'
    }
  },
  computed: {
    menu() {
      return [
        {
          name: 'basico',
          label: 'Básico'
        }
      ]
    }
  }
}
</script>
